var SET_CLIENT_PAGINATION = 'SET_CLIENT_PAGINATION';
var SET_SERVER_PAGINATION = 'SET_SERVER_PAGINATION';
var SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
var SET_COLUMN = 'SET_COLUMN';
var SET_COLUMNS = 'SET_COLUMNS';
var SET_SORTED_DISPLAY_DATA = 'SET_SORTED_DISPLAY_DATA';
var SET_PAGE_SIZE = 'SET_PAGE_SIZE';
var SET_NEXT_PAGE = 'SET_NEXT_PAGE';
var SET_PREV_PAGE = 'SET_PREV_PAGE';
var SET_LAST_PAGE = 'SET_LAST_PAGE';
var SET_FIRST_PAGE = 'SET_FIRST_PAGE';
var SET_GENERAL_STATE = ' SET_GENERAL_STATE';
var SET_GROUP_CHILD_ROWS_ON_PAGE = 'SET_GROUP_CHILD_ROWS_ON_PAGE';
var SINGLE_ROW_SELECT = 'single';
var MULTIPLE_ROW_SELECT = 'multiple';
var SET_SELECTED_ROWS = 'SET_SELECTED_ROWS';
var NEXT = 'NEXT';
var PREV = 'PREV';
var FIRST = 'FIRST';
var LAST = 'LAST';
var SERVER = 'server';
var INITIAL_STATE = {
  alternateRowColor: false,
  cellPadding: 'normal',
  columns: {
    columnDefs: [],
    hasRowGroup: false,
    sort: {}
  },
  displayData: [],
  groupChildRowsOnPage: [],
  pagination: {
    currentPage: 1,
    hidePagination: true,
    pageSelector: true,
    pageSizeOptions: [25, 50, 100]
  },
  scrollableWidth: false,
  selectedRows: [],
  showGrid: true
};

export { FIRST, INITIAL_STATE, LAST, MULTIPLE_ROW_SELECT, NEXT, PREV, SERVER, SET_CLIENT_PAGINATION, SET_COLUMN, SET_COLUMNS, SET_CURRENT_PAGE, SET_FIRST_PAGE, SET_GENERAL_STATE, SET_GROUP_CHILD_ROWS_ON_PAGE, SET_LAST_PAGE, SET_NEXT_PAGE, SET_PAGE_SIZE, SET_PREV_PAGE, SET_SELECTED_ROWS, SET_SERVER_PAGINATION, SET_SORTED_DISPLAY_DATA, SINGLE_ROW_SELECT };
